/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-imports */

import * as React from 'react';
import { TextButton, IconButton } from '@oneaudi/unified-web-components';
import { UeContainer, UeElement, UeReference } from '@oneaudi/falcon-tools';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import Slider from 'react-slick';
import { useI18n } from '@oneaudi/i18n-context';
import { FeatureGalleryTextBlock } from '../feature-gallery-text-block/index';
import WLTPComponent from '../MediaDisclaimerAndWLTP';
import {
  CarouselContainer,
  ContentContainer,
  FlexContainer,
  SliderWrap,
  SlideText,
  SlickSlider,
  ImageContainer,
  TextBlockSlider,
  TextBlockContent,
} from './style';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { constants } from '../../../constants';
import { VideoPLayer } from '../feature-gallery-popeye-video';
import { useWindowSize } from '../../../helper/useWindowSize';
import { messages } from '../../../i18n/messages';
import ImageComponent from './Image';
import { trackClick } from '../../utilTrackingHelpers/click';
import { MaybeLink } from './MaybeLink';

interface FeatureGalleryProps {
  content?: any;
  localeService?: LocaleServiceV1;
  gallery?: any;
  theme?: string;
  autoplay?: boolean;
  autoplaySpeed?: number;
  mediaHeight?: string;
  trackingService: TrackingServiceV2;
  featureAppId: string;
}

const AUTOPLAY_RESUME_IDLE_DELAY_MS = 10000;

export const hasTouchInput = () => typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0;

export const shouldWaitForAutoplayVideo = (
  asset: unknown,
  carouselAutoplay: boolean | undefined,
  isTouchDevice: boolean,
) => {
  if (!carouselAutoplay || !isTouchDevice || typeof asset !== 'object' || asset === null) {
    return false;
  }

  const videoAsset = asset as Record<string, unknown>;
  return videoAsset.assetType === constants.assetType.video && videoAsset.autoPlay === true;
};

const getGalleryItemKey = (element: any, index: number): string =>
  String(
    element?.id ??
      element?.path ??
      element?.asset?.imageUrlLargeViewport?.assetValue ??
      element?.asset?.imageUrlSmallViewport?.assetValue ??
      element?.asset?.videoUrlLargeViewport?.assetValue ??
      element?.asset?.videoUrlSmallViewport?.assetValue ??
      `gallery-item-${index}`,
  );

const FeatureGallery: React.FC<FeatureGalleryProps> = (props) => {
  const [nav1, setNav1] = React.useState<Slider | null>(null);
  const [nav2, setNav2] = React.useState<Slider | null>(null);
  const startX = React.useRef<number | null>(null);
  const [lastInteraction, setLastInteraction] = React.useState<string>('click');
  const [isAutoplayPausedByInteraction, setIsAutoplayPausedByInteraction] = React.useState(false);
  const [isSlideTransitioning, setIsSlideTransitioning] = React.useState(false);
  const [activeSlideGeneration, setActiveSlideGeneration] = React.useState(0);
  const [videoPlaybackState, setVideoPlaybackState] = React.useState<{
    generation: number;
    status: 'idle' | 'playing' | 'paused';
  }>({ generation: 0, status: 'idle' });

  const slider1 = React.useRef<Slider | null>(null);
  const slider2 = React.useRef<Slider | null>(null);
  const autoplayResumeTimeoutRef = React.useRef<number | null>(null);
  const activeSlideRef = React.useRef({ index: 0, generation: 0 });
  const touchStartGenerationRef = React.useRef<number | null>(null);
  const endedVideoGenerationRef = React.useRef<number | null>(null);
  const ref = React.useRef(null);
  const wltpRef = React.useRef(null);
  const [mediaSize, setMediaSize] = React.useState('Large');
  const [paginationWidth, setPaginationWidth] = React.useState<number | undefined>(undefined);
  const size = useWindowSize();

  // eslint-disable-next-line
  const divRefSlide1 = React.useRef<HTMLDivElement | null>(null!);
  const divRefSlide2 = React.useRef<HTMLDivElement | null>(null);
  const fgData = props;

  const { gallery, autoplay, autoplaySpeed, mediaHeight = 'large', trackingService } = fgData;

  const slidesCount = gallery ? gallery.length - 1 : 0;
  const [isCurrent, setIsCurrent] = React.useState<number>(0);

  const ueElementImageProperty = `imageUrl${mediaSize}Viewport`;
  const ueElementVideoProperty = `videoUrl${mediaSize}Viewport`;
  const previousSlide = useI18n(messages.previousSlide);
  const nextSlide = useI18n(messages.nextSlide);
  const currentSlidAriaText = useI18n(messages.currentSlide);
  const jumpToAriaText = useI18n(messages.jumpTo);

  const isAlpha = !process.env.IS_LEGACY;
  const isTouchDevice = hasTouchInput();
  const shouldWaitForCurrentAutoplayVideo = shouldWaitForAutoplayVideo(
    gallery?.[isCurrent]?.asset,
    autoplay,
    isTouchDevice,
  );
  const isCurrentTouchVideoPlayingOrPaused =
    videoPlaybackState.generation === activeSlideGeneration &&
    (videoPlaybackState.status === 'playing' || videoPlaybackState.status === 'paused');
  const isCurrentTouchVideoBlockingAutoplay =
    isCurrentTouchVideoPlayingOrPaused || shouldWaitForCurrentAutoplayVideo;

  React.useEffect(() => {
    const updateSize = () => {
      setMediaSize(window.innerWidth > 767 ? 'Large' : 'Small');
    };

    updateSize();

    window.addEventListener('resize', updateSize);
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  const textBlockTabHandler = () => {
    // eslint-disable-next-line
    const activeSlide = divRefSlide2?.current?.querySelectorAll('.slick-slide')!;

    activeSlide?.forEach((slide) => {
      if (slide.classList.contains('slick-active')) {
        slide.querySelectorAll('a').forEach((a) => (a.tabIndex = 0));
      } else if (!slide.classList.contains('slick-active')) {
        slide.querySelectorAll('a').forEach((a) => (a.tabIndex = -1));
      }
    });
  };

  const indexTabHandler = () => {
    // eslint-disable-next-line
    const activeSlide = divRefSlide1?.current?.querySelectorAll('.slick-slide')!;
    activeSlide?.forEach((slide) => {
      if (slide.classList.contains('slick-active')) {
        slide.querySelectorAll('button').forEach((button) => (button.tabIndex = 0));
      } else if (!slide.classList.contains('slick-active')) {
        slide.querySelectorAll('button').forEach((button) => (button.tabIndex = -1));
      }
    });
    textBlockTabHandler();
  };

  React.useEffect(() => {
    // eslint-disable-next-line
    setNav1(slider1.current!);
    // eslint-disable-next-line
    setNav2(slider2.current!);
    indexTabHandler();
  }, []);

  React.useEffect(() => {
    const handleMouseDown = () => {
      setLastInteraction('click');
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        setLastInteraction('keyboard');
      }
    };

    const handleTouchStart = () => {
      setLastInteraction('swipe');
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('touchstart', handleTouchStart);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('touchstart', handleTouchStart);
    };
  }, []);

  const clearAutoplayResumeTimeout = React.useCallback(() => {
    if (autoplayResumeTimeoutRef.current !== null) {
      window.clearTimeout(autoplayResumeTimeoutRef.current);
      autoplayResumeTimeoutRef.current = null;
    }
  }, []);

  const pauseAutoplayTemporarily = React.useCallback(() => {
    if (!autoplay) return;
    clearAutoplayResumeTimeout();
    setIsAutoplayPausedByInteraction(true);
  }, [autoplay, clearAutoplayResumeTimeout]);

  const resumeAutoplayAfterIdle = React.useCallback(() => {
    if (!autoplay) return;
    clearAutoplayResumeTimeout();
    autoplayResumeTimeoutRef.current = window.setTimeout(() => {
      setIsAutoplayPausedByInteraction(false);
    }, AUTOPLAY_RESUME_IDLE_DELAY_MS);
  }, [autoplay, clearAutoplayResumeTimeout]);

  React.useEffect(() => {
    return () => {
      clearAutoplayResumeTimeout();
    };
  }, [clearAutoplayResumeTimeout]);

  React.useEffect(() => {
    if (!slider1.current || !autoplay || isTouchDevice) return;

    if (isAutoplayPausedByInteraction) {
      slider1.current.slickPause();
      return;
    }

    slider1.current.slickPlay();
  }, [autoplay, isAutoplayPausedByInteraction, isTouchDevice]);

  React.useEffect(() => {
    if (!slider1.current || !isTouchDevice) return;

    // Always clear react-slick's previous interval before deciding how the active slide proceeds.
    slider1.current.slickPause();
    if (autoplay && !isSlideTransitioning && !isCurrentTouchVideoBlockingAutoplay) {
      slider1.current.slickPlay();
    }
  }, [
    activeSlideGeneration,
    autoplay,
    isCurrentTouchVideoBlockingAutoplay,
    isSlideTransitioning,
    isTouchDevice,
  ]);

  const isActiveVideoLifecycle = React.useCallback((index: number, generation: number) => {
    const activeSlide = activeSlideRef.current;
    return activeSlide.index === index && activeSlide.generation === generation;
  }, []);

  const onVideoStarted = React.useCallback(
    (index: number, generation: number) => {
      if (!isTouchDevice || !autoplay || !isActiveVideoLifecycle(index, generation)) return;
      slider1.current?.slickPause();
      setVideoPlaybackState({ generation, status: 'playing' });
    },
    [autoplay, isActiveVideoLifecycle, isTouchDevice],
  );

  const onVideoPaused = React.useCallback(
    (index: number, generation: number) => {
      if (!isTouchDevice || !autoplay || !isActiveVideoLifecycle(index, generation)) return;
      slider1.current?.slickPause();
      setVideoPlaybackState({ generation, status: 'paused' });
    },
    [autoplay, isActiveVideoLifecycle, isTouchDevice],
  );

  const onVideoEnded = React.useCallback(
    (index: number, generation: number) => {
      if (
        !isTouchDevice ||
        !autoplay ||
        !isActiveVideoLifecycle(index, generation) ||
        endedVideoGenerationRef.current === generation
      ) {
        return;
      }

      endedVideoGenerationRef.current = generation;
      slider1.current?.slickPause();
      setVideoPlaybackState({ generation, status: 'idle' });
      slider1.current?.slickNext();
    },
    [autoplay, isActiveVideoLifecycle, isTouchDevice],
  );

  const handleSlideChange = React.useCallback(
    (next: number) => {
      if (isTouchDevice) {
        // Cancel the old slide's interval synchronously, before React unmounts its video player.
        slider1.current?.slickPause();
        setIsSlideTransitioning(true);
      }

      const generation = activeSlideRef.current.generation + 1;
      activeSlideRef.current = { index: next, generation };
      endedVideoGenerationRef.current = null;
      setVideoPlaybackState({ generation, status: 'idle' });
      setActiveSlideGeneration(generation);
      setIsCurrent(next);
    },
    [isTouchDevice],
  );

  const getPaginationWidth = React.useCallback((): number | undefined => {
    return divRefSlide2.current?.querySelector('ul')?.offsetWidth;
  }, []);

  React.useEffect(() => {
    const updatePaginationWidth = () => {
      const width = getPaginationWidth();
      if (width !== undefined) {
        setPaginationWidth(width);
      }
    };

    updatePaginationWidth();
    window.addEventListener('resize', updatePaginationWidth);

    return () => {
      window.removeEventListener('resize', updatePaginationWidth);
    };
  }, [getPaginationWidth, size.width, gallery?.length]);

  const settings1 = {
    autoplay,
    autoplaySpeed,
    pauseOnHover: true,
    pauseOnFocus: true,
    accessibility: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    lazy: true,
    touchMove: true,
    draggable: true,
    beforeChange: (_current: number, next: number) => {
      handleSlideChange(next);
    },
    afterChange: () => {
      if (isTouchDevice) setIsSlideTransitioning(false);
      indexTabHandler();
    },
  };

  const settings2 = {
    accessibility: true,
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    adaptiveHeight: true,
    beforeChange: (_current: number, next: number) => {
      handleSlideChange(next);
    },
    afterChange: () => {
      indexTabHandler();
    },

    customPaging: (i: number) => {
      return (
        <React.Fragment>
          <SlideText
            data-testid={`carouselPagination-${i + 1}`}
            key="carouselPaginationLink"
            isAlpha={isAlpha}
          >
            {i === 0 && (
              <FlexContainer>
                <IconButton
                  icon="back"
                  size="md"
                  data-testid="carouselPrevArrow"
                  className="prev"
                  variant="tertiary"
                  aria-label={previousSlide}
                  onClick={() => {
                    if (isTouchDevice && autoplay) slider1.current?.slickPause();
                    slider1.current?.slickPrev();
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'arrow',
                      value: 'pagination bar',
                      pos: `${isCurrent - 1 === -1 ? isCurrent + 1 : isCurrent + 1}~${isCurrent - 1 === -1 ? gallery.length : isCurrent}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: 'back-small',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                />
                <TextButton
                  variant="tertiary"
                  data-testid={`carouselPaginationButton-${i + 1}`}
                  id={`pagination${i + 1}`}
                  aria-label={
                    isCurrent === i
                      ? `${currentSlidAriaText} ${i + 1}`
                      : `${jumpToAriaText} ${i + 1}`
                  }
                  className="goTo"
                  onClick={() => {
                    if (isTouchDevice && autoplay) slider1.current?.slickPause();
                    slider1.current?.slickGoTo(i);
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'number',
                      value: 'pagination bar',
                      pos: `${isCurrent + 1}~${i + 1}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: '',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                >
                  {i + 1}
                </TextButton>
              </FlexContainer>
            )}

            {i > 0 && i < slidesCount && (
              <TextButton
                variant="tertiary"
                data-testid={`carouselPaginationButton-${i + 1}`}
                id={`pagination${i + 1}`}
                aria-label={
                  isCurrent === i ? `${currentSlidAriaText} ${i + 1}` : `${jumpToAriaText} ${i + 1}`
                }
                className="goTo"
                onClick={() => {
                  if (isTouchDevice && autoplay) slider1.current?.slickPause();
                  slider1.current?.slickGoTo(i);
                  const eventObj = {
                    eventAction: 'image',
                    eventName: 'feature gallery - change image',
                    elementName: 'number',
                    value: 'pagination bar',
                    pos: `${isCurrent + 1}~${i + 1}`,
                    actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                    label: '',
                  };
                  trackClick(trackingService, eventObj);
                }}
              >
                {i + 1}
              </TextButton>
            )}

            {i === slidesCount && (
              <FlexContainer>
                <TextButton
                  variant="tertiary"
                  data-testid={`carouselPaginationButton-${i + 1}`}
                  id={`pagination${i + 1}`}
                  aria-label={
                    isCurrent === i
                      ? `${currentSlidAriaText} ${i + 1}`
                      : `${jumpToAriaText} ${i + 1}`
                  }
                  className="goTo"
                  onClick={() => {
                    if (isTouchDevice && autoplay) slider1.current?.slickPause();
                    slider1.current?.slickGoTo(i);
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'number',
                      value: 'pagination bar',
                      pos: `${isCurrent + 1}~${i + 1}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: '',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                >
                  {i + 1}
                </TextButton>

                <IconButton
                  data-testid="carouselNextArrow"
                  icon="forward"
                  size="md"
                  variant="tertiary"
                  className="next"
                  aria-label={nextSlide}
                  onClick={() => {
                    if (isTouchDevice && autoplay) slider1.current?.slickPause();
                    slider1.current?.slickNext();
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'arrow',
                      value: 'pagination bar',
                      pos: `${isCurrent + 1}~${isCurrent + 1 >= gallery.length ? 1 : isCurrent + 2}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: 'forward-small',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                />
              </FlexContainer>
            )}
          </SlideText>
        </React.Fragment>
      );
    },
  };

  const handleStart = (e: React.TouchEvent | React.MouseEvent) => {
    if ('touches' in e) {
      if (autoplay) slider1.current?.slickPause();
      touchStartGenerationRef.current = activeSlideRef.current.generation;
      startX.current = e.touches[0].clientX;
    } else {
      pauseAutoplayTemporarily();
      startX.current = e.clientX;
    }
  };

  const handleEnd = (e: React.TouchEvent | React.MouseEvent) => {
    if ('changedTouches' in e) {
      // A tap does not invoke beforeChange, so explicitly give it a fresh delay. A swipe is
      // restarted by the active-slide effect after react-slick commits the new slide.
      if (
        autoplay &&
        touchStartGenerationRef.current === activeSlideRef.current.generation &&
        !isCurrentTouchVideoBlockingAutoplay
      ) {
        slider1.current?.slickPlay();
      }
      touchStartGenerationRef.current = null;
    } else {
      resumeAutoplayAfterIdle();
    }
    if (startX.current === null) return;

    let endX: number;

    if ('changedTouches' in e) {
      endX = e.changedTouches[0].clientX;
    } else {
      endX = e.clientX;
    }

    const deltaX = endX - startX.current;

    if (Math.abs(deltaX) > 30) {
      const direction = deltaX > 0 ? 'right' : 'left';
      const eventObj = {
        eventAction: 'image',
        eventName: 'feature gallery - change image',
        elementName: 'image',
        value: 'image bar',
        pos: `${isCurrent + 1}~${isCurrent + 1 >= gallery.length ? 1 : isCurrent + 2}`,
        actionType: 'swipe',
        label: 'forward-small',
      };
      if (direction == 'right') {
        eventObj.pos = `${isCurrent - 1 === -1 ? isCurrent + 1 : isCurrent + 1}~${isCurrent - 1 === -1 ? gallery.length : isCurrent}`;
        trackClick(trackingService, eventObj);
      } else {
        eventObj.pos = `${isCurrent + 1}~${isCurrent + 1 >= gallery.length ? 1 : isCurrent + 2}`;
        trackClick(trackingService, eventObj);
      }
    }

    startX.current = null;
  };

  return (
    <SlickSlider
      color="primary"
      data-testid="impression-tracking-box"
      id="impression-tracking-box"
      ref={ref}
      onTouchStart={handleStart}
      onTouchEnd={handleEnd}
      onMouseDown={handleStart}
      onMouseUp={handleEnd}
      onFocus={pauseAutoplayTemporarily}
      onBlur={resumeAutoplayAfterIdle}
    >
      <UeContainer propertyPath="gallery" label="Gallery">
        <CarouselContainer data-testid="featureGalleryCarousel" isAlpha={isAlpha}>
          <SliderWrap
            data-testid="featureGalleryMedia"
            isSingleSlide={gallery.length === 1}
            ref={divRefSlide1}
          >
            <Slider
              {...settings1}
              asNavFor={nav2!}
              adaptiveHeight
              ref={(slider: Slider) => (slider1.current = slider)}
            >
              {gallery?.map((element: any, index: number) => (
                <UeReference
                  key={getGalleryItemKey(element, index)}
                  propertyPath={`gallery.${index}`}
                  behavior="component"
                >
                  <UeContainer propertyPath={`gallery.${index}.asset`} label="Gallery Image Asset">
                    <UeReference propertyPath={`gallery.${index}.asset`} behavior="component">
                      {(ueProps) => (
                        <ContentContainer
                          data-testid={`carouselItem-${index + 1}`}
                          className="main-container"
                          size={size.width}
                          mediaHeight={mediaHeight}
                          {...ueProps}
                        >
                          {element?.asset?.assetType === constants?.assetType?.image ? (
                            <UeElement type="media" property={ueElementImageProperty} label="Image">
                              <ImageContainer className="image" size={size.width}>
                                <MaybeLink
                                  testId={`carouselItemImageLink-${index + 1}`}
                                  ctaUrl={element?.cta1?.ctaLink1}
                                  openIn={element?.cta1?.openIn}
                                  ariaLabel={
                                    element?.cta1?.ctaAria1 || element?.asset?.alternateDescription
                                  }
                                  onClick={() => {
                                    if (element?.cta1?.ctaLink1) {
                                      const ctaLink = String(element.cta1.ctaLink1);
                                      const eventObj = {
                                        targetURL: ctaLink,
                                        eventAction: trackingService.evaluateLinkType(
                                          ctaLink,
                                        ) as string,
                                        eventName: 'feature gallery - click on image',
                                        elementName: 'image',
                                        value: '',
                                        pos: `${index + 1}`,
                                        actionType: lastInteraction,
                                        label: element?.asset?.alternateDescription || '',
                                      };
                                      trackClick(trackingService, eventObj);
                                    }
                                  }}
                                >
                                  <ImageComponent
                                    testId={`carouselItemImage-${index + 1}`}
                                    largeImageSrc={
                                      element?.asset?.imageUrlLargeViewport?.assetValue
                                    }
                                    smallImageSrc={
                                      element?.asset?.imageUrlSmallViewport?.assetValue
                                    }
                                    preserveImageWidth={element?.asset?.preserveImageWidth}
                                    mediaHeight={mediaHeight}
                                    alternateDescription={element?.asset?.alternateDescription}
                                    alternateDescriptionPortrait={
                                      element?.asset?.alternateDescriptionPortrait ||
                                      element?.asset?.alternateDescription
                                    }
                                  />
                                </MaybeLink>
                              </ImageContainer>
                            </UeElement>
                          ) : (
                            isCurrent === index && (
                              <VideoPLayer
                                asset={element?.asset}
                                ueElementProperty={ueElementVideoProperty}
                                isCurrent={isCurrent}
                                index={index}
                                height={divRefSlide1.current?.offsetHeight}
                                testId={`carouselItemVideo-${index + 1}`}
                                galleryInstanceId={props.featureAppId}
                                onPlaybackStarted={() => {
                                  onVideoStarted(index, activeSlideGeneration);
                                }}
                                onPlaybackPaused={() => {
                                  onVideoPaused(index, activeSlideGeneration);
                                }}
                                onPlaybackEnded={() => {
                                  onVideoEnded(index, activeSlideGeneration);
                                }}
                              />
                            )
                          )}
                        </ContentContainer>
                      )}
                    </UeReference>
                  </UeContainer>
                </UeReference>
              ))}
            </Slider>
          </SliderWrap>
          <TextBlockSlider
            data-testid="featureGalleryContent"
            isSingleSlide={gallery.length === 1}
            ref={divRefSlide2}
            width={paginationWidth}
            isAlpha={isAlpha}
          >
            <Slider
              {...settings2}
              asNavFor={nav1!}
              adaptiveHeight
              ref={(slider: Slider) => (slider2.current = slider)}
            >
              {gallery?.map(
                (
                  element: any,

                  index: number,
                ) => (
                  <UeReference
                    key={getGalleryItemKey(element, index)}
                    propertyPath={`gallery.${index}`}
                    behavior="component"
                  >
                    {(ueProps) => (
                      <div key={index} {...ueProps}>
                        <TextBlockContent
                          data-testid={`carouselItemDescription-${index + 1}`}
                          className="ctas"
                        >
                          <FeatureGalleryTextBlock
                            ctaLink={element?.cta1 ? element.cta1.ctaLink1 : null}
                            ctaText={element?.cta1 ? element.cta1.ctaText1 : null}
                            ariaLabel={element?.cta1 ? element.cta1.ctaAria1 : null}
                            title={element.title}
                            bodyText={element.bodyText}
                            openIn={element.cta1 ? element?.cta1?.openIn : null}
                            width={paginationWidth}
                            slideIndex={index}
                            trackingService={trackingService}
                            isCurrent={isCurrent}
                            {...ueProps}
                          />
                        </TextBlockContent>

                        {element.legalText?.mediaDisclaimer || element.legalText?.wltpKey ? (
                          <WLTPComponent
                            mediaDisclaimer={element.legalText?.mediaDisclaimer}
                            wltpTextValues={element.legalText?.wltpKey}
                            localeService={props.localeService}
                            wltpRef={wltpRef}
                          />
                        ) : null}
                      </div>
                    )}
                  </UeReference>
                ),
              )}
            </Slider>
          </TextBlockSlider>
        </CarouselContainer>
      </UeContainer>
    </SlickSlider>
  );
};

export default FeatureGallery;
